import React from 'react';
import Paper from "@material-ui/core/Paper/index";
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {Divider} from "@material-ui/core";
import TitlePage from "../../../../app/Title/TitlePage/TitlePageView";
import LinearProgress from "@material-ui/core/LinearProgress";
import Typography from "@material-ui/core/Typography";
import {Dropdown} from "primereact/dropdown";
import {Checkbox} from "primereact/checkbox";
import InstitutionDropDown from "../../../../components/dropDown/institution";
import SubtitleLabel from "../../../../app/Title/SubtitleLabel/SubtitleLabelView";
import PropTypes from "prop-types";

const UpdateUserView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                {props.messagesGrowl}
                <div className="p-grid">
                    <div className="p-col-7">
                        <TitlePage title={props.newUser ?
                            "Mantenimientos \\ Usuarios \\ Agregar" :
                            "Mantenimientos \\ Usuarios \\ Editar"}/>
                    </div>
                    <div className="p-col-5" align="right">
                        <Button label="Regresar" className="p-button-secondary"
                                onClick={props.returnMaintenanceUsersPage}
                                tabIndex={16}/>&nbsp;
                        {!props.newUser ?
                            <Button label="Permisos" className="p-button-secondary"
                                    onClick={props.redirectPermissions}
                                    tabIndex={15}
                            /> : ""
                        }
                        &nbsp; <Button label="Guardar"
                                       onClick={props.updateUser}
                                       tabIndex={14}/>
                    </div>
                    <div className="p-col-12"><Divider/></div>

                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Usuario" isBold={true}/>
                        {props.newUser ?
                            <InputText name="usuario" placeholder="Ex: Usuario 1"
                                       required={true} keyfilter="alphanum"
                                       onChange={props.onChangeText}
                                       value={props.userData.usuario}
                                       maxLength={15}
                                       className={props.errors.usuario ? 'p-error' : ''}
                                       onPaste={(e) => {e.preventDefault();}}
                                       autoComplete="off"
                                       tabIndex={1}/> :
                            <SubtitleLabel header={props.userData.usuario}/>
                        }

                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Estatus" isBold={true}/>
                        <Dropdown name="statusObj"
                                  options={props.statusList}
                                  filterBy="status"
                                  optionLabel="status"
                                  placeholder="Seleccione..."
                                  onChange={props.onChangeDropDown}
                                  value={props.userData.statusObj}
                                  className={props.errors.statusObj ? 'p-error' : ''}
                                  tabIndex={5}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Nombre" isBold={true}/>
                        <InputText name="nombre" placeholder="Ex: Nombre"
                                   keyfilter={/^[a-zA-Z_áéíóúñ\s]*$/}
                                   required={true}
                                   maxLength={20}
                                   className={props.errors.nombre ? 'p-error' : ''}
                                   onChange={props.onChangeText}
                                   value={props.userData.nombre}
                                   tabIndex={props.newUser ? 2 : 1}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Teléfono 1" isBold={true}/>
                        <InputText name="telefono1" placeholder="Ex: 5511223344"
                                   keyfilter="pint"
                                   required={true} maxLength={15}
                                   className={props.errors.telefono1 ? 'p-error' : ''}
                                   onChange={props.onChangeText}
                                   value={props.userData.telefono1}
                                   tabIndex={6}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Apellido Paterno" isBold={true}/>
                        <InputText name="apellidoPaterno" placeholder="Ex: apellido"
                                   keyfilter={/^[a-zA-Z_áéíóúñ\s]*$/}
                                   required={true}
                                   maxLength={20}
                                   className={props.errors.apellidoPaterno ? 'p-error' : ''}
                                   onChange={props.onChangeText}
                                   value={props.userData.apellidoPaterno}
                                   tabIndex={3}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Teléfono 2" isBold={true}/>
                        <InputText name="telefono2" placeholder="Ex: 5511223344"
                                   keyfilter="pint"
                                   maxLength={15}
                                   onChange={props.onChangeText}
                                   value={props.userData.telefono2}
                                   tabIndex={7}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Apellido Materno" isBold={true}/>
                        <InputText name="apellidoMaterno" placeholder="Ex: Apellido"
                                   keyfilter={/^[a-zA-Z_áéíóúñ\s]*$/}
                                   onChange={props.onChangeText}
                                   maxLength={20}
                                   value={props.userData.apellidoMaterno}
                                   tabIndex={4}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Fax" isBold={true}/>
                        <InputText name="fax" placeholder="Ex: 5511223344"
                                   keyfilter="pint" maxLength={15}
                                   onChange={props.onChangeText}
                                   value={props.userData.fax}
                                   tabIndex={8}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Tipo Usuario" isBold={true}/>
                        {(props.isInterno && props.newUser) ?
                            <Dropdown name="typeUsrObj"
                                      options={props.typeUsrList}
                                      filterBy="tipoUsuario"
                                      optionLabel="tipoUsuario"
                                      placeholder="Seleccione..."
                                      onChange={props.onChangeDropDown}
                                      value={props.userData.typeUsrObj}
                                      className={props.errors.typeUsrObj ? 'p-error' : ''}
                                      tabIndex={9}/> :
                            <SubtitleLabel header={props.userData.tipoUsuario}/>
                        }
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Institución" isBold={true}/>
                        {(props.isInterno && props.newUser) ?
                            <InstitutionDropDown
                                name="instObj"
                                filter="nombreCorto"
                                save={props.onChangeDropDown}
                                value={props.userData.instObj}
                                loading={props.loading}
                                disabled={props.instDisabled}
                                tabIndex={10}/> :
                            <SubtitleLabel header={props.userData.nombreCorto}/>
                        }

                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Correo" isBold={true}/>
                        <InputText name="userEmail" placeholder="Ex: usuario 1"
                                   required={true} keyfilter={/^[a-zA-Z0-9_.-]*$/}
                                   onChange={props.onChangeText}
                                   value={props.userData.userEmail}
                                   maxLength={50}
                                   className={props.errors.userEmail ? 'p-error' : ''}
                                   autoComplete="off"
                                   tabIndex={11}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Dominio" isBold={true}/>
                        <Dropdown name="domainObj"
                                  options={props.domainList}
                                  filterBy="dominio"
                                  optionLabel="dominio"
                                  placeholder="Seleccione..."
                                  onChange={props.onChangeDropDown}
                                  value={props.userData.domainObj}
                                  className={props.errors.domainObj ? 'p-error' : ''}
                                  tabIndex={12}/>
                    </div>
                    <div className="p-col-12">
                        <Typography variant="subtitle2" gutterBottom style={{fontWeight: "bolder"}}
                                    tabIndex={13} className={"secondary-text"}>
                            <Checkbox name="banderaMfa"
                                      checked={props.userData.isMfa}
                                      onChange={props.onChangeCheckMfa}/>&nbsp;
                            Verificación en dos pasos
                        </Typography>
                    </div>
                </div>
            </Paper>
        </React.Fragment>
    )
};

export default /*withStyles(styles)*/(UpdateUserView);

UpdateUserView.propTypes = {
    userData: PropTypes.object.isRequired,
};